import { render, staticRenderFns } from "./DeleteDataModal.vue?vue&type=template&id=40ddd43a"
import script from "./DeleteDataModal.vue?vue&type=script&lang=js"
export * from "./DeleteDataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports